// Same-origin in production: Caddy proxies /api to the backend, so a relative
// path works and avoids CORS. For local dev, set REACT_APP_API_BASE in
// portal-frontend/.env.local (e.g. http://localhost:8000/api) when the React
// dev server runs on a different port than the API.
export const API_BASE = process.env.REACT_APP_API_BASE || '/api';

/**
 * Authenticated fetch wrapper
 * Automatically includes JWT token in Authorization header
 */
export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  const headers = {
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add Content-Type for JSON requests if not already set
  if (options.body && typeof options.body === 'string' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  // If unauthorized, clear token and redirect to login
  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    throw new Error('Unauthorized - please login again');
  }

  return response;
};

